import { Checkbox } from "@chakra-ui/checkbox";
import { Box } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { ParametrosAreaComum } from "core/features/area-comum/typings";
import { Control, UseFormWatch, UseFormSetValue } from "react-hook-form";
import Field from "components/Input/Field";
import InputMoney from "components/Input/InputMoney";

export interface ParametrosAreaComumFormProps {
  control: Control<ParametrosAreaComum, object>;
  watch: UseFormWatch<ParametrosAreaComum>;
  setValue: UseFormSetValue<ParametrosAreaComum>;
}

function ParametrosAreaComumForm({
  control,
  watch,
  setValue,
}: ParametrosAreaComumFormProps) {
  return (
    <form id="parametros-area-comum">
      <Box px={1}>
        <Box mb="16px">
          <Row gutter={16}>
            <Col sm={14}>
              <Field
                label="Prazo para pagamento do boleto (dias)"
                control={control}
                name="diaVencimento"
                rules={{ required: "Campo obrigatório" }}
                render={({ field, isInvalid }) => (
                  <InputMoney
                    {...field}
                    isInvalid={isInvalid}
                    allowDecimals={false}
                    decimalScale={0}
                    placeholder="0"
                    maxValue={31}
                  />
                )}
              />
            </Col>

            <Col sm={10}>
              {!!watch("cancelamentoAutomatico") ? (
                <Field
                  label="Dias para o cancelamento"
                  control={control}
                  name="diasCancelamentoAutomatico"
                  rules={{ required: "Campo obrigatório" }}
                  render={({ field, isInvalid }) => (
                    <InputMoney
                      {...field}
                      isInvalid={isInvalid}
                      allowDecimals={false}
                      decimalScale={0}
                      placeholder="0"
                    />
                  )}
                />
              ) : null}
            </Col>
          </Row>
        </Box>

        <Box mb="16px">
          <Field
            control={control}
            name="realizarReservaAntesUtilizarOutra"
            render={({ field }) => (
              <Checkbox
                isChecked={!!field.value}
                onChange={() => field.onChange(!field.value)}
              >
                Bloquear novas reservas caso haja reserva pendente ou confirmada
                ainda não utilizada, independentemente da área comum
              </Checkbox>
            )}
          />
        </Box>

        <Box mb="16px">
          <Field
            control={control}
            name="bloquearInadimplente"
            render={({ field }) => (
              <Checkbox
                isChecked={!!field.value}
                onChange={() => field.onChange(!field.value)}
              >
                Bloquear inadimplentes de fazer reservas
              </Checkbox>
            )}
          />
        </Box>

        <Box mb="16px">
          <Field
            control={control}
            name="cancelamentoAutomatico"
            render={({ field }) => (
              <Checkbox
                isChecked={!!field.value}
                onChange={() => {
                  setValue("diasCancelamentoAutomatico", null);

                  field.onChange(!field.value);
                }}
              >
                Cancelar reserva automaticamente após o vencimento do boleto?
              </Checkbox>
            )}
          />
        </Box>

        <Box mb="16px">
          <Field
            control={control}
            name="primeiraReservaAnoGratis"
            render={({ field }) => (
              <Checkbox isChecked={!!field.value} onChange={field.onChange}>
                Primeira reserva do ano para cada unidade é gratuita?
              </Checkbox>
            )}
          />
        </Box>
      </Box>
    </form>
  );
}

export default ParametrosAreaComumForm;
